import React, { ReactElement, useState } from 'react'
import { RADOM_COLORS } from '../util/Constants'
import { PrimaryButton, SecondaryButton } from './Button'
import Modal, { ModalFooter } from './Modal'

function ConfirmButtonModal({ ActionComponent, ...props }): ReactElement {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const confirm = async (e: React.MouseEvent): Promise<void> => {
    e.preventDefault()
    e.stopPropagation()

    setIsLoading(true)
    props.onConfirm()
      .then(() => setIsVisible(false))
      .finally(() => {
        setIsLoading(false)
      })
  }

  return <>
    <ActionComponent onClick={(e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      setIsVisible(true)
    }} />
    <Modal
      visible={isVisible}
      onClose={() => setIsVisible(false)}
      title={props.title}
      innerStyles={{ width: '420px', minHeight: 'auto' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontSize: 14, color: RADOM_COLORS.GRAY_DARKEST, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
          {props.description}
        </span>
        <ModalFooter $fullWidthAction>
          <SecondaryButton
            type='button'
            disabled={isLoading}
            style={{ width: '100%' }}
            onClick={() => setIsVisible(false)}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            isLoading={isLoading}
            type='button'
            style={{ width: '100%' }}
            onClick={confirm}>
            {props.action}
          </PrimaryButton>
        </ModalFooter>
      </div>
    </Modal>
  </>
}

export default ConfirmButtonModal
